import { Nullable } from '@clearverify/types';
import { convertCentsToDollars } from '@clearverify/utils';

import { VerifierStaffWithBillingInfoFragment } from 'src/api';

import { ActiveBillingRateItemType } from '../types';

export const getActiveBillingRatesData = (
  verifierStaffBillingInfo: Nullable<VerifierStaffWithBillingInfoFragment>,
): ActiveBillingRateItemType[] => [
  {
    title: 'VoE',
    value: convertCentsToDollars(verifierStaffBillingInfo?.verifier.verifierBilling?.voE),
    description: 'price for each Verification\n of Employment',
  },
  {
    title: 'VoI',
    value: convertCentsToDollars(verifierStaffBillingInfo?.verifier.verifierBilling?.voI),
    description: 'price for each Verification\n of Income',
  },
  {
    title: 'Reverification',
    value: convertCentsToDollars(
      verifierStaffBillingInfo?.verifier.verifierBilling?.reverification,
    ),
    description: 'price for each further Verification\n (Reverification)',
  },
];
